import React, { useState } from "react";
import { Typography, Card, Pagination, Link, Grid, Box } from "@mui/material";
import { base64UrlEncode } from "./podcastUtils";
import { StyledCards, StyledGrid } from "../style/StyledComponents";
import { useNavigate } from "react-router-dom";

const PodcastBoard = ({podcasts, rssFeed}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const Iconstyle = { width: '100%', height: "100%", objectFit: 'cover', cursor: 'pointer' };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = podcasts ? podcasts.slice(indexOfFirstItem, indexOfLastItem) : [];

  const navigate = useNavigate();

  const handleClick = (params) => {
    if (rssFeed && params.mp3) {
      const encodedPodcast = base64UrlEncode(rssFeed);
      const encodedMp3 = base64UrlEncode(params.mp3);
      navigate(`/podcasts/${encodedPodcast}/mp3/${encodedMp3}`, { state: { ...params, rssFeed} });
    }
  };

  return (
    <>
      <StyledGrid container item spacing={2}>
          {currentItems.map((video) => (
            <Grid item key={video.title}>
              <StyledCards>
              <img
                src={video.image}
                alt={video.title}
                style={Iconstyle}
                onClick={() => handleClick(video)} 
              />
                <Grid container>
                    <Grid item xs={12}>
                        <Typography
                        variant="body1"
                        sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                        >
                        <Link sx={{ cursor: 'pointer' }}
                            onClick={() => handleClick(video)}
                        > {video.title}</Link>
                        </Typography>
                    </Grid>
                </Grid>
              </StyledCards>
            </Grid>
          ))}
        </StyledGrid>
        <Box display="flex" justifyContent="center" width="100%" mt={2}>
          <Pagination
            count={Math.ceil(podcasts.length / itemsPerPage)}
            page={currentPage}
            onChange={handlePageChange}
            style={{ margin: "20px" }}
          />
        </Box>
      </>
  );
};

export default PodcastBoard;